/**
 * The label for hour `hour` (0-23) in `locale`: `12am`, `1pm` in English.
 * Built on a fixed date, so a DST change on the day it runs never shifts an hour.
 * @param {number} hour
 * @param {string} locale
 * @returns string
 */
export function hourLabel(hour, locale) {
  const parts = new Intl.DateTimeFormat(locale, {
    hour: 'numeric',
  }).formatToParts(new Date(2000, 0, 1, hour));
  const dayPeriod = parts.find((part) => part.type === 'dayPeriod');

  if (!dayPeriod) return parts.map((part) => part.value).join('');

  const hourPart = parts.find((part) => part.type === 'hour');
  return `${hourPart.value}${dayPeriod.value.toLowerCase()}`;
}

/**
 * The 24 hour labels of a day in `locale`, from midnight
 * @param {string} locale
 * @returns string[]
 */
export function hourLabels(locale) {
  return Array.from({ length: 24 }, (_, hour) => hourLabel(hour, locale));
}

/**
 * The `y` values of server `{x, y}` points as 24 hour slots, keyed on the
 * English hour in `x`, so the series stays aligned with labels in any locale.
 * Hours without a point are `null`.
 * @param {{x: string, y: ?number}[]} points
 * @returns {?number[]}
 */
export function seriesByHour(points) {
  const englishHours = hourLabels('en');
  const series = Array(24).fill(null);

  points.forEach((point) => {
    series[englishHours.indexOf(point.x)] = point.y;
  });

  return series;
}
